import { render, staticRenderFns } from "./LemniscataBernoulli.vue?vue&type=template&id=8fb81a04&scoped=true&"
import script from "./LemniscataBernoulli.vue?vue&type=script&lang=js&"
export * from "./LemniscataBernoulli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb81a04",
  null
  
)

export default component.exports